module.exports = __webpack_public_path__ + "img/icon-close-circle-orange.9f9bbcbe.svg";